export default "__VITE_ASSET__dafc6f3a__"